import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IS_NOT_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

@Component({
	selector: 'app-toggleable-button',
	templateUrl: './toggleable-button.component.html',
	styleUrls: ['./toggleable-button.component.scss'],
})
export class ToggleableButtonComponent implements OnInit {
	@Input() label: string;
	@Input() value: string;
	@Input() count: number;
	@Input() isSelected: boolean = false;
	@Output() buttonSelected: EventEmitter<string> = new EventEmitter();

	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;

	constructor() {}

	ngOnInit(): void {}
}
